<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import { navigate } from "../../../../vendor/svelte-routing"
    import { langField } from "../../i18n"
    import { breadcrumbs } from "../../store"
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/svelte-splide"
    import { mdiArrowLeft, mdiArrowRight } from "@mdi/js"
    import Icon from "../widgets/Icon.svelte"

    let sliders = []
</script>

{#if $breadcrumbs?.length && $breadcrumbs[$breadcrumbs.length - 1].children?.length}
    <div id="teaserconfigmodule">
        {#each $breadcrumbs[$breadcrumbs.length - 1].childObjects as c, index (c.id)}
            <div
                class="item"
                class:slider="{c.images}"
                on:click|stopPropagation="{() => {
                    if (!c.images) navigate(langField(c.path, ''))
                }}"
                on:keydown
            >
                <div class="image" class:slider="{c.images}">
                    {#if c.images}
                        <Splide
                            class="main-slider"
                            aria-label="Main Slider - {langField(c.name, '')}"
                            options="{{
                                rewind: true,
                                perPage: 1,
                                autoplay: true,
                                interval: 3000,
                                type: 'fade',
                                speed: 2000,
                            }}"
                            hasTrack="{false}"
                        >
                            <div class="custom-wrapper">
                                <SplideTrack>
                                    {#each c.images as image}
                                        <SplideSlide>
                                            <div
                                                bind:clientWidth="{sliders[index]}"
                                                style="{'height:' +
                                                    (sliders?.length
                                                        ? (sliders[0] / 16) * 9 !== 0
                                                            ? (sliders[0] / 16) * 9 + 'px'
                                                            : 30 + 'vh'
                                                        : 'auto')}"
                                                on:click|stopPropagation="{() => {
                                                    navigate(langField(c.path, ''))
                                                }}"
                                                on:keydown
                                            >
                                                {#if image.file.src.startsWith("https")}
                                                    <img
                                                        src="{image.file.src + '?filter=l'}"
                                                        alt="{langField(image.file.path, '')}"
                                                        on:keydown
                                                    />
                                                {:else}
                                                    <img
                                                        src="{c.image?.src
                                                            ? c.image.src + '?filter=m'
                                                            : '/media/kein-bild.jpg'}"
                                                        alt="{langField(c.name, '')}"
                                                    />
                                                {/if}
                                            </div>
                                        </SplideSlide>
                                    {/each}
                                </SplideTrack>

                                <div class="splide__actions">
                                    <div class="splide__arrows">
                                        <button class="splide__arrow splide__arrow--prev">
                                            <div class="gradient"></div>
                                            <div class="icon">
                                                <Icon path="{mdiArrowLeft}" size="24px" />
                                            </div>
                                        </button>
                                        <button class="splide__arrow splide__arrow--next">
                                            <div class="gradient"></div>
                                            <div class="icon">
                                                <Icon path="{mdiArrowRight}" size="24px" />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Splide>
                    {:else}
                        <a on:click|preventDefault="{() => {}}" href="{langField(c.path, '')}">
                            <img
                                src="{c.image?.src ? c.image.src + '?filter=m' : '/media/kein-bild.jpg'}"
                                alt="{langField(c.name, '')}"
                            />
                        </a>
                    {/if}
                </div>
                <div
                    class="text"
                    on:click|preventDefault="{() => {
                        if (c.images) navigate(langField(c.path, ''))
                    }}"
                    on:keydown
                >
                    <div class="inner">
                        {#if c.title}
                            <h3>
                                {langField(c.title, "")}
                            </h3>
                        {:else}
                            {langField(c.name, "")}
                        {/if}

                        <div class="teasertext">
                            {langField(c.teaser_text, "")}
                        </div>
                    </div>
                    <div class="btn btn-secondary">
                        {#if c.button_text}
                            {langField(c.button_text, "")}
                        {:else if c.filterConfig?.length}
                            {$_("econfig-teaser.to-configurator")}
                        {:else}
                            {$_("econfig-teaser.to-products")}
                        {/if}
                    </div>
                    <div class="arrow">
                        <ChevronDownIcon size="28" />
                    </div>
                </div>
            </div>
        {/each}
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    #teaserconfigmodule {
        .flex();
        align-items: stretch;
        justify-content: center;

        @media (max-width: 470px) {
            flex-direction: column;
        }

        .item {
            cursor: pointer;
            background: var(--surface-2);
            color: var(--on-surface-2);
            .flex();
            flex: 1;
            flex-direction: column;

            @media (max-width: 470px) {
                &:not(.slider) {
                    flex-direction: row;
                }
            }

            .image {
                width: 100%;
                position: relative;

                @media (max-width: 650px) {
                    &:not(.slider) {
                        height: 12vw;
                    }
                }
                @media (max-width: 470px) {
                    height: auto;
                    flex-shrink: 0;
                    height: auto;
                    width: 100%;

                    &:not(.slider) {
                        width: 100px;
                    }
                }
                a {
                    display: block;
                    line-height: 0;
                    height: 100%;
                }

                &:not(.slider) {
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }

            .text {
                .flex();
                flex-direction: column;
                flex-grow: 1;
                justify-content: space-between;
                padding: 50px;
                position: relative;
                @media (max-width: 1000px) {
                    padding: 25px 35px 25px 25px;
                    // justify-content: center;
                    // align-items: center;
                }
                @media (max-width: 600px) {
                    padding: 15px 25px 15px 15px;
                }
                @media (max-width: 470px) {
                    align-items: flex-start;
                }
                .arrow :global {
                    display: none;
                    svg {
                        transform: rotate(-90deg);
                    }
                    //@media (max-width: 768px) {
                    @media (max-width: 470px) {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        right: 0;
                        width: 50px;
                        .flex();
                        align-items: center;
                        justify-content: center;
                    }
                    @media (max-width: 600px) {
                        width: 30px;
                    }
                }
            }

            h3 {
                margin: 0px;

                @media (max-width: 1270px) {
                    font-size: 1.3rem;
                }
                @media (max-width: 1000px) {
                    font-size: 1rem;
                }
                @media (max-width: 768px) {
                    font-size: 1.2rem;
                }
                @media (max-width: 650px) {
                    font-size: 1rem;
                }
            }

            .btn {
                margin-top: 20px;
                font-size: 1rem;
                align-self: flex-start;
                @media (max-width: 1000px) {
                    font-size: 0.8rem;
                }
                // @media (max-width: 768px) {
                @media (max-width: 470px) {
                    font-size: 1rem;
                    display: none;
                }
            }

            .teasertext {
                line-height: 1.3;
                @media (max-width: 1000px) {
                    font-size: 0.8rem;
                }
                /*@media (max-width: 768px) {
                    font-size: 1rem;
                    display: none;
                }*/
            }

            &:nth-child(2) {
                background: var(--comp--teaserconfigmodule--2th-item--background);
                color: var(--comp--teaserconfigmodule--2th-item--color);
            }
        }
    }
</style>
